/**
 * Timeline Constants
 *
 * All configuration constants for the crop schedule timeline component.
 * Extracted for reusability and consistent spacing across all timeline components.
 */

// Row heights and gaps
export const COLLAPSED_ROW_HEIGHT = 28
export const COLLAPSED_ROW_HEIGHT_GAP = 5
export const PRINT_COLLAPSED_ROW_HEIGHT = 18
export const PRINT_COLLAPSED_ROW_HEIGHT_GAP = 3
export const EXPANDED_ROW_HEIGHT = 13 * 6.5  // 84.5
export const EXPANDED_ROW_HEIGHT_GAP = 6

// Task rendering
export const TASK_BOOKMARK_HEIGHT = 80  // Larger than phase bookmarks to accommodate notes

// Succession row heights
export const SUCCESSION_THIN_HEIGHT = 4   // px — "almost a line" when parent is collapsed
export const SUCCESSION_THIN_GAP = 2      // px — gap between thin succession lines
export const SUCCESSION_EXPANDED_HEIGHT = COLLAPSED_ROW_HEIGHT  // when parent is expanded

// Group layout
export const GROUP_GAP = COLLAPSED_ROW_HEIGHT_GAP * 2  // 10
export const GROUP_HEADER_HEIGHT = 20

// Tracker and selector
export const VERTICAL_DAY_TRACKER_SPACE = 2.4
export const SELECTOR_BOTTOM_PADDING = 16

// Axis dimensions
export const X_AXIS_HEIGHT = 70
export const Y_AXIS_TYPOGRAPHY_PAD_R = 2
export const Y_AXIS_GRADIENT_MASK_WIDTH = 250

// Reports
export const REPORT_MARKER_HEIGHT = 19.5
export const REPORT_MARKER_WIDTH = 50
export const REPORT_LINE_WIDTH = 1

// Scroll and zoom
export const WEEK_CONTAINER_FALLBACK_WIDTH = 32

// Date range offsets
export const RANGE_START_LFD_OFFSET_MONTHS = 5  // months before last frost date
export const RANGE_END_FFD_OFFSET_MONTHS = 2   // months after first frost date

// utils
export const WEEK_MS = 7 * 24 * 60 * 60 * 1000
